// @ts-nocheck
/* eslint-disable */
import React, { useEffect, useState } from 'react';

import { CircularProgress } from '@material-ui/core';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Modal } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';

import { getStations } from 'actions';
import { uploadMultipleStationsApi } from 'app/operations/stations/station-api';
import { useTypedSelector } from 'helpers';
import { getIsSuperAdmin } from 'selectors';

interface Props {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  page?: number;
  rowsPerPage?: number;
}

const UploadStationsModal: React.FC<Props> = ({
  isOpen,
  setOpen,
  page = 0,
  rowsPerPage = 10,
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const currentLanguageCode =
    localStorage.getItem('EASY_MOBILITY_LANGUAGE') || 'en-us';

  const [isUploading, setIsUploading] = useState(false);
  const isSuperAdmin = useTypedSelector(getIsSuperAdmin);

  // Warn user on page close while uploading
  useEffect(() => {
    const handleBeforeUnload = e => {
      if (isUploading) {
        e.preventDefault();
        e.returnValue = '';
      }
    };

    if (isUploading) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isUploading]);

  const close = () => {
    if (isUploading) return;
    setOpen(false);
  };

  const handleFileUpload = async e => {
    const file = e.target.files?.[0];
    if (!file) return;

    setIsUploading(true);
    try {
      await uploadMultipleStationsApi(file);
      toast.success(intl.formatMessage({ id: 'successUploadStations' }));
      setOpen(false);
      dispatch(getStations(page, rowsPerPage));
    } catch (err: any) {
      const data = err?.response?.data;
      let message = data?.message || err?.message || 'Upload failed';
      if (Array.isArray(message)) {
        message = message.map(m => m?.message || m).join(' | ');
      }
      toast.error(String(message), {
        position: 'top-right',
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
      });
    } finally {
      setIsUploading(false);
      e.target.value = '';
    }
  };

  const handleTemplateDownload = () => {
    const headers = isSuperAdmin
      ? ['command', 'station_id', 'en_name', 'ar_name', 'station_code', 'org_en_name']
      : ['command', 'station_id', 'en_name', 'ar_name', 'station_code'];

    const sampleRow = isSuperAdmin
      ? ['add', '', 'Station One', 'محطة واحد', 'ABC123', 'Org Name']
      : ['add', '', 'Station One', 'محطة واحد', 'ABC123'];

    const ws = XLSX.utils.aoa_to_sheet([headers, sampleRow]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Stations');
    XLSX.writeFile(wb, 'Stations_Template.xlsx');
  };

  return (
    <Modal show={isOpen} onHide={close} style={{ zIndex: 9999969 }}>
      {isUploading ? (
        <Modal.Body>
          <div
            style={{
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
              margin: '2px',
            }}
          >
            <CircularProgress style={{ width: 50 }} />
          </div>
        </Modal.Body>
      ) : (
        <>
          <Modal.Body>
            <label
              htmlFor="stations-file-upload"
              className=" upload-style-btn-label mt-3"
            >
              <FileUploadIcon /> {intl.formatMessage({ id: 'UploadFile' })}
            </label>

            <input
              id="stations-file-upload"
              type="file"
              accept=".csv,.xls,.xlsx"
              onChange={handleFileUpload}
              style={{ display: 'none' }}
              disabled={isUploading}
            />

            <button
              type="button"
              className="download-style-btn"
              onClick={handleTemplateDownload}
            >
              <DownloadIcon />
              {intl.formatMessage({ id: 'DownloadTemplate' })}
            </button>
          </Modal.Body>

          <Modal.Footer
            style={{
              direction: currentLanguageCode === 'en-us' ? 'ltr' : 'rtl',
            }}
          >
            <button
              type="button"
              className="download-style-btn"
              onClick={close}
            >
              {intl.formatMessage({ id: 'Cancel' })}
            </button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

export { UploadStationsModal };
